const LOCAL_HOSTS = [
  'localhost',
  '0.0.0.0',
  'github',
  '.black',
  '.internal'
];

const isActiveElement = () => {
  if (document && document.activeElement) {
    return document.activeElement.id === 'searchKeywords';
  }
  return false;
};

const getSearchBoxOptions = (state) => {
  const { isDesktop, system: { siteName, environment }} = state;
  const hostName = window.location.hostname;

  const config = {
    site: siteName,
    environment,
    serverRendered: true,
    focusKeywords: isDesktop || isActiveElement(),
    isReadyToUseFn: () => {},
    externalContainer: 'body',
    enableFocusFix: true,
    typeahead: {
      baseUrl: LOCAL_HOSTS.includes(hostName) && 'https://test.homeaway.com/' || '/',
      remotePath: 'typeahead'
    }
  };

  if (siteName === 'vrbo') {
    config.searchForm = {
      submitUrl: '/results'
    };
  }

  return config;
};

export default getSearchBoxOptions;



// WEBPACK FOOTER //
// ./src/universal/utils/getSearchBoxOptions.js